
// 知识文档
<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box" @tab-click="handleClick">
			<el-tab-pane label="列表" name="second">
				<div class="grid-height" style="display:flex">
					<!-- 左边------- 树型结构 -->
					<div class="left_tree">

						<div style="padding: 5px;margin: 0px 8px;   max-height: 70vh;
    overflow: hidden;
    overflow-y: scroll;border: 1px solid #ededed;">
							<div class="title"> <svg t="1676961094129" class="icon tree_icon" viewBox="0 0 1024 1024"
									version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2887" width="20" height="20">
									<path
										d="M384 725.333333c0 21.333333 17.066667 38.4 38.4 42.666667H640v-42.666667c0-21.333333 17.066667-38.4 38.4-42.666666H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666666v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666667h-213.333333c-68.266667 0-123.733333-51.2-128-119.466666V341.333333H170.666667c-21.333333 0-38.4-17.066667-42.666667-38.4V128c0-25.6 17.066667-42.666667 42.666667-42.666667h341.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666666H384v128h256v-42.666666c0-21.333333 17.066667-38.4 38.4-42.666667H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666666c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666666H384v170.666666z m426.666667 42.666667h-85.333334v85.333333h85.333334v-85.333333z m0-298.666667h-85.333334v85.333334h85.333334v-85.333334z m-341.333334-298.666666H213.333333v85.333333h256V170.666667z"
										fill="#1296db" p-id="2888"></path>
								</svg>

								<span>知识分类</span>
							</div>
							<el-input placeholder="关键字过滤" v-model="filterText">
							</el-input>

              <!-- 树型结构 -->
              <el-tree class="tree-line"
                       ref="tree"
                       :lazy="true"
                       :data="treeData"
                       :props="{ label: 'name', children: 'children', isLeaf: 'leaf', dataId: 'dataId', }"
                       :load="loadNode"
                       node-key="id"
                       @node-click="nodeClick"
                       :filter-node-method="filterNode"
              >
                <div class="comp-tr-node" slot-scope="{ node, data }" style="position: relative;">
                  <template>
                    <!-- 名称： 新增节点增加class（is-new） -->
                    <span class="node_width">{{ node.label }} </span>
                    <!-- 按钮 -->
                    <span style="position: absolute;top: -6px;left: 85px;">

                      </span>
                  </template>
                </div>
              </el-tree>
						</div>
					</div>
					<div class="table_main" style="height: calc(100vh - -30px);">
						<vxe-grid ref="table-m1" show-overflow height="100%" :stripe="true" border="default" :row-config="{ isHover: true }"
							v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
							@custom="$vxeTableUtil.customHandle">

							<template #form>
								<div class="clearfix screen-btns">
									<div class="fl">
										<!-- <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
											@click="openEditDialog" v-if="itemSave">新增</vxe-button> -->
									</div>
									<div class="fr">
<!--										<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
<!--											status="primary" plain>重置</vxe-button>-->
										<vxe-button status="warning" icon="el-icon-search" class="button-sty"
											@click="searchEvent">搜索</vxe-button>
									</div>
								</div>
								<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
									:data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
									<!-- <vxe-form-item title="品牌名称:" field="brandName">
										<template v-slot>
											<el-input v-model="formData.brandName" size="small" clearable />
										</template>
									</vxe-form-item> -->
									<vxe-form-item title="标题:" field="itemCode">
										<template v-slot>
											<el-input v-model="formData.title" size="small" clearable />
										</template>
									</vxe-form-item>
									<vxe-form-item title="关键字:" field="itemName">
										<template v-slot>
											<el-input v-model="formData.keyWords" size="small" clearable />
										</template>
									</vxe-form-item>
								</vxe-form>
							</template>
							<template #pager>
								<pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
							</template>
						</vxe-grid>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<detailsDialog v-if="showDetailsDialog" @closeD="closeD" :row1="row1"
                     :visiable.sync="showDetailsDialog"
                     multi="true"/>
	</div>
</template>

<script>
import {indexPageMixins} from '@/mixins/tabChang'
import {initVxeTable} from '@/const/crud/admin/table';
import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
// 知识详情
import detailsDialog from "./detailsDialog.vue";
import api from "@/api/projectApi";
export default {
	name: 'data',

  mixins: [indexPageMixins],
	components: {  pager, detailsDialog,},
	data() {
		return {
      treeData: [],

			showDetailsDialog: false,
      row1: null,

      itemSave: false,
      itemEdit: false,
      total: 0,
			filterText: '',
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label',
				id: "id",
				isLeaf: "leaf"
			},
			pageSizes: [10, 20, 100],
			//以上树形
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			// 查询参数
			formData: {
        title: null,
        keyWords: null
			},
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        title: null,
        keyWords: null,
        knowledgeTypeId: null,
      }
		};
	},
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.itemSave = this.permissions['item_add']
    this.itemEdit = this.permissions['item_edit']
  },
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
	},
	methods: {
		toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
    nodeClick(data) {
      this.requestParam.knowledgeTypeId = data.id
      this.searchEvent()
    },

    // 节点加载
    loadNode(node, resolve) {
      if (node.level === 0) {// 根节点，父id为0
        this.requestTreeData(null, resolve)
      } else {
        this.requestTreeData(node.data.id, resolve)
      }
    },

    // 树形控件数据请求
    requestTreeData(parentId, resolve) {
      this.$http.post(api.basKnowledgeType.getTreeData, {parentId: parentId}).then(res => {
        resolve(res.data.data.map(item => {
          return {id: item.id, name: item.typeName, leaf: !item.hasChild}
        }))
      })
    },




		// 分页功能
		changeTablePage(page, flag) {
			console.log('分页数据', page, this.formData)
			this.requestParam.size = page.pageSize
			this.requestParam.current = page.currentPage
			this.requestParam.searchCount = flag
			this.getTableData();
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},

		// 搜索
		searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.$refs['table-m1'].commitProxy('reload')
		},

		// // 重置
		// resetEvent() {
		// 	this.formData = {};
		// 	this.formData.addresswangdian = {};
		// 	this.$refs.pager.reset()  // 重置分页器
		// 	this.$refs['table-m1'].commitProxy('reload');
		// },
		closeD(v) {
      // this.reload()
      console.log(v, "v的值");
      this.showDetailsDialog = v

    },
		// 查看详情
		openEditDialog(row) {
      console.log(row, "点击的数据")
      this.row1 = row
      console.log(this.row1, "this.row1ddddddddd");
      this.showDetailsDialog = true


      // this.itemId = row.id
    },
		// 点击的树形 点
		handleNodeClick(node, data) {
			console.log(data, "点击data的值");
			let id = data.data.id;
			console.log(id, "点击id的值");
			if (data.level === 1) {
				// this.formData={};
				this.formData.bigCategoryId = id;
				this.formData.smallCategoryId = '';
			} else {
				// this.formData={};
				this.formData.smallCategoryId = id;
			}

			console.log(this.formData, "this.formData的值");
			this.getTableData();

			this.$refs['table-m1'].commitProxy('reload');

		},

    getTableData() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: api.basKnowledge.getPageDataUrl,
				param: this.requestParam,
				method: 'post',

				columns: [
					{ type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },

					{
						title: '标题',
						field: 'title',
						width: 200,
					},
					{
						title: '关键字',
						field: 'keyWords',
						width: 150,
					},
					{
						title: '知识库分类',
						field: 'knowledgeTypeName',
						width: 120,
						// fixed: 'left'
					},
					{
						title: '是否置顶',
						field: 'isTop',
						width: 120,
						slots: {
							default: ({ row }) => {
								if (row.isSettle == 0) {
									return [
										<div class="txt-status disable">
											<span>否</span>
										</div>
									];
								} else if (row.isSettle == 1) {
									return [
										<div class="txt-status">
											<span>是</span>
										</div>
									];
								}
							}
						}
					},
					{
						title: '是否发布',
						field: 'isPublic',
						width: 120,
						slots: {
							default: ({ row }) => {
								if (row.usable == 0) {
									return [
										<div class="txt-status disable">
											<span>否</span>
										</div>
									];
								} else if (row.usable == 1) {
									return [
										<div class="txt-status">
											<span>是</span>
										</div>
									];
								}
							}
						}
					},
					{
						field: 'createTime',
						title: '创建时间',
						width: 150
					},
					{
						title: '创建人',
						field: 'createBy',
						width: 120,

					},
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<div>
										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.openEditDialog(row.id);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-edit" />
											</el-tooltip>
										</a>
									</div>
								];
							}
						}
					}
				]
			};
			// initVxeTable(tableOption).then(opts => {
			this.vxeOption = initVxeTable(tableOption);
			this.$refs['table-m1'].commitProxy('reload');
			// console.log(initVxeTable(tableOption),"vxeOption-表头的值及属性");
			// });
		},
		// 加载页面
		loadChildNode(node, resolve) {
			console.log(node, "loadChildNode.node")
      fetchTree({
        parentId: node.data.id,
        categoryType: 1
      }).then(({data}) => {
        console.log(data, "data.data的值")
        resolve(
          data.data.map(item => {
            return {
              label: item.categoryName,
              id: item.id,
              leaf: Number(item.isChild) == 1 ? false : true,
            }
          })
        )
      });
			// this.treeData=data.data


		},


	}
};
</script>
<style lang="scss" scoped>
::v-deep .el-tree {
    font-size: 13px;}
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}

.table_main {
	padding-top: 5px;
	padding-left: 5px;
	border: 1px solid #ededed;
	width: calc(100% - 215px);
	border-bottom: none;

	.el-pagination {
		padding: 2px;

	}
}

.left_tree {
	width: 205px;

	.title {
		text-align: left;
		width: 182px;
		padding: 7px 0 5px !important;
		font-size: 13px;
		color: rgba(58, 39, 39, 0.96);

		>span {
			position: relative;
			left: 4px;
			top: -3px;
		}
	}

	::v-deep.el-tree-node__label {
		width: calc(100% - 32px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		color: rgba(86, 86, 86, 0.96);
	}
}

.tree_icon {
	background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
	.el-tree-node {
		position: relative;
		padding-left: 0px;
	}

	.el-tree-node__content {
		margin-top: 0px;
	}

	.el-tree-node__children {
		padding-left: 16px;
	}

	.el-tree-node::before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -3px;
		top: -26px;
		border-width: 1px;
		border-left: 1px dashed #d9d9d9;
	}

	.el-tree-node:last-child::before {
		height: 38px;
	}

	.el-tree-node::after {
		content: '';
		width: 24px;
		height: 1px;
		position: absolute;
		left: -3px;
		top: 12px;
		border-width: 1px;
		border-top: 1px dashed #d9d9d9;
	}

	&>.el-tree-node::after {
		border-top: none;
	}

	&>.el-tree-node::before {
		border-left: none;
	}

	.el-tree-node__expand-icon {
		font-size: 17px;

		// color: #000;
		&.is-leaf {
			color: transparent;
			// display: none;
		}
	}
}</style>

